'use strict';

DoohApps
    .factory('Voucher', ['restApi', function (restApi) {
        var controllerName = 'Invoice/';

        return {
            getVoucherList: function (successCallback, applicationId, mediaId, groupID, expiredDate, issuedDate) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetVoucherList?applicationId=' + applicationId + '&mediaId=' + mediaId + '&groupId=' + groupID + '&expiredDate=' + expiredDate + '&issuedDate=' + issuedDate);
            },
            getLicenses: function (successCallback, ApplicationId, mediaId) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetLicenses?ApplicationId=' + ApplicationId + '&MediaId=' + mediaId);
            },
            getLicensesList: function (successCallback, ApplicationId) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetLicensesList?ApplicationId=' + ApplicationId);
            },
            getCompanyConsumerVouchers: function (successCallback) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetCompanyConsumerVouchers');
            },
            voucherFiltering: function (successCallback, objectFilterOptions) {
                restApi.GetApiMethod(successCallback, controllerName + 'VoucherFiltering', objectFilterOptions);
            },
            addVoucher: function (successCallback, data) {
                restApi.PostApiMethod(successCallback, controllerName + 'AddVoucher', data);
            },
            getLicensesForDevices: function (successCallback, filter) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetLicensesForDevices', filter);
            },
            makeTransaction: function (successCallback, payment) {
                restApi.PostApiMethod(successCallback, controllerName + 'PostTransaction', payment);
            },
            setVoucherInvalid: function (successCallback, voucherId) {
                restApi.DeleteApiMethod(successCallback, controllerName + 'SetVoucherInvalid?voucherID=' + voucherId);
            },
            getVoucherUsage: function (successCallback, data) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetVoucherUsage' , data)
            }
        }
    }])
.factory('VoucherFilterData', function () {
    var DataFilter = {};

    DataFilter.SetDefault = function () {
        DataFilter.VoucherFilter = {};
        DataFilter.VoucherFilter.Offset = 0;
        DataFilter.VoucherFilter.Count = 8;
        DataFilter.VoucherFilter.expired = false;
        DataFilter.VoucherFilter.valid = true;
        DataFilter.VoucherFilter.useStatus = 3;
        DataFilter.VoucherFilter.applicationId = null;
        DataFilter.VoucherFilter.vendorId = null;
        DataFilter.VoucherFilter.name = '';
        DataFilter.VoucherFilter.issuedToObject = null;
        DataFilter.VoucherFilter.issuedTo = null;
        DataFilter.VoucherFilter.createOrder = 0;
        DataFilter.VoucherFilter.nameOrder = 0;
        DataFilter.VoucherFilter.statusOrder = 0;
        DataFilter.VoucherFilter.issueDateOrder = 0;
        DataFilter.VoucherFilter.expireDateOrder = 0;
        DataFilter.VoucherFilter.issuedByOrder = 0;
        DataFilter.VoucherFilter.issuedToOrder = 0;
        DataFilter.VoucherFilter.screenCountOrder = 0;
        DataFilter.VoucherFilter.appCountOrder = 0;
        DataFilter.VoucherFilter.voucherIdOrder = 1;
        DataFilter.VoucherFilter.TotalCount = 0;
        DataFilter.SelectedVoucher = {};
    };
    DataFilter.SetDefault();

    DataFilter.Clear = function () {
        DataFilter.SetDefault();
    }

    DataFilter.prepSelectedVoucher = function (that) {
        this.SelectedVoucher = that;
    }

    return DataFilter;
});
